import { MutationTree } from 'vuex';
import { AdminState } from './types';
import { ISkyHubUser } from '@/models/SkyHubUser';

export const mutations: MutationTree<AdminState> = {
  SET_ALL_USERS(state, users: ISkyHubUser[]) {
    state.users = users;
  }
};
